import "./CGU.css";
import "../components/fonts.css";
import Landing_header from "../components/Landing_header.js";

function CONFIDENTIALITE() {
  return (
    <>
      <Landing_header />
      <div className="Landing">
        <>
          <h1 className="title">Politique de confidentialité Happer</h1>
          <p className="disc1">
            Nous pouvons recueillir et traiter les données suivantes vous
            concernant
          </p>
          <p className="title2">1. Informations </p>
          <p className="disc">
            Les informations que vous fournissez en remplissant des formulaires
            sur nos sites et applications. Cela inclut les informations fournies
            au moment de l’enregistrement pour utiliser notre site et nos
            applis. Si vous nous contactez, nous pouvons garder une trace de
            cette correspondance. Nous pouvons également vous demander de
            remplir des sondages que nous utilisons à des fins de recherche,
            même si vous n'avez pas à y répondre. Détails des transactions que
            vous effectuez sur notre site et nos applis et des offres (réussies
            ou non) que vous pouvez faire au cours d’une vente aux enchères.
            Détails de vos visites sur notre application, y compris les données
            de trafic, les données de localisation et autres données de
            communication, si ce est nécessaire pour nos propres fins de
            facturation ou autre, et les ressources auxquelles vous accédez.
            Nous pouvons vous demander de fournir des informations sur vos
            intérêts et / ou les préférences afin que les informations sur notre
            application vous soient présentées de la manière la plus efficace.
          </p>
          <p className="title2">2. Adresses IP </p>
          <p className="disc">
            Nous pouvons collecter des informations sur votre ordinateur, y
            compris le cas échéant votre adresse IP, système d’exploitation et
            le type de navigateur, pour l’administration système et de rendre
            compte des informations globales à nos annonceurs. Ce sont des
            données statistiques sur les actions et les habitudes de navigation
            de nos utilisateurs, et ne permettent pas d’identifier un individu.
          </p>
          <p className="title2">3. Cookies</p>
          <p className="disc">
            Pour la même raison, nous pouvons obtenir des informations sur votre
            utilisation générale d’Internet en utilisant un fichier cookie qui
            est stocké sur le disque dur de votre ordinateur. Les cookies
            contiennent des informations qui sont transférées sur le disque dur
            de votre ordinateur. Ils nous aident à améliorer notre site et nos
            applis et à fournir un service meilleur et plus personnalisé. Ils
            nous permettent d'estimer la taille de notre auditoire et le mode
            d’utilisation. Pour stocker des informations sur vos préférences, et
            ainsi nous permettre de personnaliser notre site et nos applis en
            fonction de vos intérêts individuels. Pour accélérer vos recherches.
            Pour vous reconnaître lorsque vous revenez sur notre site et nos
            applis. Pour utiliser notre site et nos applis d’une manière qui
            rend votre expérience de navigation plus pratique, par exemple, si
            vous vous inscrivez avec nous ou remplissez notre formulaire en
            ligne, nous allons utiliser des cookies pour mémoriser vos
            coordonnées lors de votre visite actuelle, et lors de voyages futurs
            fourni le cookie était pas supprimés dans l’intérim. En particulier,
            les cookies nous permettent entre autres; - pour vous rappeler votre
            identification de session. afin de déterminer si vous êtes connecté.
            utiliser la fonction “se souvenir de moi” sur nos applis. se
            souvenir de votre adresse e-mail qui nous permet de pré-remplir le
            formulaire de connexion. pour stocker votre choix de «grille» ou
            «liste» modes d’affichage lorsque vous parcourez les pages de la
            liste de surveillance de notre catalogue. Si vous vous inscrivez
            avec nous ou si vous continuez à utiliser notre site et nos applis,
            vous acceptez notre utilisation des cookies.
          </p>
          <p className="title2">4. Données </p>
          <p className="disc">
            Lorsque nous stockons vos données personnelles Les informations que
            vous nous fournissez sont stockées sur nos serveurs ou ceux de nos
            sous-traitants. Nous et nos sous-traitants prendrons des mesures
            raisonnables pour protéger vos informations. Toutes les transactions
            de paiement seront cryptées en utilisant la “...“ Lorsque vous avez
            choisi un ID utilisateur et mot de passe qui vous permet d’accéder à
            certaines parties de notre site et nos applis, vous êtes responsable
            de maintenir votre ID d’utilisateur et mot de passe confidentiel.
            Nous vous demandons de ne pas partager votre nom d’utilisateur et
            mot de passe avec personne. Malheureusement, la transmission
            d’informations via Internet n'est pas entièrement sécurisée. Bien
            que nous ferons de notre mieux pour protéger vos données
            personnelles, nous ne pouvons pas garantir la sécurité de vos
            données transmises à notre site et nos applis; toute transmission
            est à vos propres risques. Une fois que nous aurons reçu vos
            informations, nous utiliserons des procédures strictes et des
            dispositifs de sécurité pour tenter d’empêcher l’accès non autorisé.
            Dans l’objectif d’inspirer la communauté Happer, toutes photos
            partagées par un utilisateur ou un influenceur sur Happer, celle-ci
            peut se retrouver dans le fil découverte de Happer avec des produits
            achetables en lien. L’utilisateur et l’influenceur a l’accès à la
            suppression des photos depuis son profil. Happer s'engage à assurer
            la sécurité des données collectées et à prendre toutes les mesures
            nécessaires pour protéger les données contre les accès non
            autorisés, les pertes ou les altérations. Happer collecte des
            données personnelles des utilisateurs, telles que le nom, l'adresse
            email, l'âge et le sexe, ainsi que des données relatives à
            l'utilisation de l'application, telles que l'historique des achats
            et les interactions avec d'autres utilisateurs. Happer utilise les
            données collectées pour assurer le bon fonctionnement de
            l'application, notamment pour permettre aux utilisateurs d'acheter
            des produits et de communiquer avec d'autres utilisateurs. Happer
            peut également utiliser les données pour améliorer l'expérience
            utilisateur et proposer des produits personnalisés. Happer ne
            partage pas les données personnelles des utilisateurs avec des tiers
            sans leur consentement. Toutefois, Happer peut partager des données
            anonymisées avec des partenaires commerciaux à des fins d'analyse et
            de marketing.
          </p>
          <p className="title2">5. Utilisations faites des informations </p>
          <p className="disc">
            Nous utilisons les informations vous concernant dans les manières
            suivantes: Pour s'assurer que le contenu de notre site et nos applis
            est présenté de la manière la plus efficace pour vous et pour votre
            appareil. Pour vous fournir les informations, produits ou services
            que vous nous demandez ou que nous pensons susceptibles de vous
            intéresser, si vous avez consenti ou autrement accepté d’être
            contacté à de telles fins par exemple en optant pour en
            communications de marketing direct lorsque vous vous inscrivez chez
            nous ou disposition contraire dans cette politique. Si vous
            choisissez de nous fournir des informations concernant vos intérêts
            et / ou les préférences, nous pouvons vous envoyer le contenu basé
            sur les informations que vous nous avez fournies. Nous pouvons
            utiliser les informations fournies par vous pour afficher des
            informations sur les produits et services que nous croyons être
            d’intérêt pour vous. Nous ne partageons pas cette information avec
            tout autre tiers sauf pour un commissaire-priseur vous devriez
            enchérir sur un objet. Pour mener à bien nos obligations découlant
            des contrats conclus entre vous et nous. Pour vous permettre de
            participer à des fonctions interactives de notre service, telles que
            des ventes aux enchères en direct, lorsque vous choisissez de le
            faire. Pour vous informer des changements à notre service. Nous ne
            sommes pas responsables pour le traitement de vos données
            personnelles par ces personnes y compris, sans s’y limiter, les
            tierces parties. C'est une affaire entre vous et la personne
            concernée. Nous agissons simplement comme un canal de communication
            de cette information. Sauf dans le cas de tiers (où leur politiquede
            confidentialité s'appliquera autant que le marketing etc est
            concerné), nous ne serons pas vos coordonnées à des tiers à des fins
            de marketing sans votre consentement. Nous pouvons également
            utiliser vos données pour vous fournir des informations sur des
            biens et services fournis par nous ou par des tiers sélectionnés qui
            peuvent être d’intérêt pour vous et nous pouvons vous contacter à
            propos de ces par la poste ou par courriel, mais seulement si vous
            avez consenti ou convenu autrement à cet exemple en optant pour en
            communications de marketing direct Lorsque vous vous inscrivez chez
            nous ou disposition contraire dans cette politique. Si vous
            consentez à l’utilisation de vos données de cette manière se il vous
            plaît cocher la case correspondante sur le formulaire sur lequel
            nous recueillons vos données (le formulaire d’inscription). Nous
            pouvons faire usage de données personnelles que nous avons
            recueillies auprès de vous pour nous permettre de se conformer aux
            souhaits de nos annonceurs en affichant leur publicité à ce public
            cible.
          </p>
          <p className="title2">6. Divulgation des renseignements </p>
          <p className="disc">
            Nous pouvons divulguer vos informations personnelles à tout membre
            de notre groupe de temps à autre ou dans nos applications. Nous
            pouvons divulguer vos renseignements personnels à des tiers: Dans le
            cas où nous vendons ou achetons une entreprise ou des actifs, auquel
            cas nous pourrons communiquer vos données personnelles au vendeur ou
            acheteur potentiel d’une telle entreprise ou des actifs. Les
            utilisateurs disposent d'un droit d'accès, de rectification, de
            suppression et d'opposition aux données les concernant. Les
            utilisateurs peuvent exercer ces droits en contactant Happer à
            l'adresse email indiquée dans l'application.
          </p>
          <p className="title2">7. Vos droits </p>
          <p className="disc">
            Vous avez le droit de nous demander de ne pas traiter vos données
            personnelles à des fins de marketing. Nous vous informerons
            normalement (avant de collecter vos données), si nous avons
            l’intention d’utiliser vos données à de telles fins ou si nous avons
            l’intention de divulguer vos informations à des tiers à de telles
            fins. Vous pouvez exercer votre droit d’empêcher un tel traitement
            en laissant certaines cases non cochées sur les formes que nous
            utilisons pour collecter vos données ou en modifiant vos
            informations en ligne. Vous pouvez également exercer le droit à tout
            moment en nous contactant.
          </p>
          <p className="title2">
            8. Changements à notre Politique de confidentialité{" "}
          </p>
          <p className="disc">
            Toute modification que nous pouvons apporter à notre politique de
            confidentialité à l’avenir sera affichée sur cette page et, le cas
            échéant, notifiée par e-mail. Cette politique de confidentialité
            remplace toutes les politiques ou les déclarations de
            confidentialité.Happer se réserve le droit de modifier la politique
            de confidentialité à tout moment. Les modifications seront publiées
            sur l'application Happer et seront applicables aux utilisateurs à
            compter de leur publication
          </p>
          <p className="title2">
            9. Charte de protection des données personnelles{" "}
          </p>
          <p className="disc">
            En supprimant votre compte, nous supprimons toutes vos données
            partagées sur Happer.
            <br />
            Toute Donnée personnelle collectée et traitée par HAPPER est
            protégée notamment par les dispositions de la Loi n° 78-17 du 6
            janvier 1978 relative à l’informatique, aux fichiers et aux
            libertés, modifiée et celles du Règlement (UE) 2016/679 du Parlement
            européen et du Conseil du 27 avril 2016 relatif à la protection des
            personnes physiques à l’égard du traitement des données à caractère
            personnel et à la libre circulation de ces données.
          </p>
          <p className="title3">a. Définitions</p>
          <p className="disc">
            a. DéfinitionsDonnées personnelles : toute information personnelle
            identifiant directement ou indirectement l’internaute ou le client
            (par exemple : nom, prénom, adresse IP ...)
            <br />
            Cookie : Un « cookie » ou traceur désigne un fichier texte
            susceptible d’être enregistré dans un espace dédié du disque dur de
            votre Terminal grâce au logiciel de navigation que vous utilisez
            pour consulter notre plateforme et sous réserve de vos choix
            enregistrés dans votre navigateur en matière de cookies. Ce fichier
            permet à son émetteur d’identifier le Terminal dans lequel il est
            enregistré, pendant la durée de validité ou d’enregistrement du
            cookie.
            <br />
            Terminal : ordinateur, tablette, smartphone.
          </p>
          <p className="title3">
            b. Gestion des données personnelles par HAPPER
          </p>
          <p className="title3">b.1 Finalité de la collecte des données </p>
          <p className="disc">
            Au travers de l’application, HAPPER recueille et traite uniquement
            les Données personnelles nécessaires à la poursuite des finalités
            suivantes :<br />
            {"   "}● La gestion des commandes et le suivi de la relation client
            : traiter vos demandes et y répondre, gérer vos commandes et les
            suites de celles-ci (par exemple facture, comptabilité, et en
            particulier gestion des comptes clients, suivi de la relation client
            tel que réalisation d’enquêtes de satisfaction, sélection de clients
            pour réaliser des études et sondages, gestion des avis clients sur
            les produits et services), sécuriser vos paiements, gérer votre
            compte et vos éventuelles réclamations et service après-vente. Pour
            tous ces cas, le traitement de vos informations a pour finalité
            l’exécution d’un contrat entre vous et HAPPER ;<br />
            {"   "}● La personnalisation de l’affichage, des préférences
            clients, de nos services et des messages que nous vous adressons :
            mieux comprendre vos intérêts et l’utilisation de nos produits et
            services afin d’améliorer nos applications et nos offres,
            personnaliser votre expérience et adapter nos activités marketing à
            vos besoins et préférences, car il est dans notre intérêt légitime
            de mieux vous servir et répondre à vos attentes ;<br />
            {"   "}● La prévention de la fraude : conserver un historique des
            transactions et autres documents commerciaux pour répondre à des
            exigences juridiques, administratives, aux besoins de nos assureurs,
            ou à des fins d’audit. Cela répond à notre intérêt légitime pour
            nous garantir contre la fraude.
            <br /> ● La sécurité et le bon fonctionnement de nos applications :
            assurer la sécurité de nos services et détecter, éviter ou retracer
            toute tentative de malveillance ou d’intrusion informatique ou toute
            violation des conditions d’utilisations des Applications car il est
            de notre intérêt légitime d’assurer la sécurité de nos activités en
            ligne comme hors ligne ;<br />
            {"   "}● La gestion des cookies : l’installation des cookies sur
            votre Terminal est soumise à votre consentement.Lors de la collecte
            des Données personnelles, les informations essentielles à la
            réalisation de ces finalités et indispensables pour répondre à vos
            demandes sont indiquées au moyen d’un astérisque. Dans le cas où
            vous n’auriez pas renseigné les champs obligatoires, nous ne serions
            pas en mesure de répondre à vos demandes.
          </p>
          <p className="title3">b.2 Fondement Juridique du traitement</p>
          <p className="disc">
            Le fondement légal du traitement de vos données peut être, suivant
            le contexte dans lequel elles sont collectées et suivant la finalité
            définie :
            <br />
            ● Votre consentement : vous acceptez le traitement de vos données
            personnelles par le biais d’un consentement exprès. Vous pouvez
            retirer ce consentement à tout moment depuis votre profil sur les
            applications HAPPER.
            <br />
            ● Nos relations contractuelles, notamment dans le cadre d’un achat,
            d’une commande ou d’une réservation : le traitement des données
            personnelles est nécessaire à l’exécution du contrat auquel vous
            avez consenti ;<br />
            ● Une obligation légale : le traitement de vos données personnelles
            est rendu obligatoire par un texte de loi.
            <br />● L’intérêt légitime : HAPPER a un intérêt commercial à
            traiter vos données qui est justifié, équilibré et ne vient pas
            porter atteinte à votre vie privée.
          </p>
          <p className="title3">b.3 Données collectées</p>
          <p className="disc">
            En fonction des Données que vous nous communiquez ou que vous
            partagez avec nous, les Données personnelles peuvent inclure des
            informations concernant :
            <br />
            Votre identité et vos coordonnées,
            <br />
            ● Vos préférences personnelles et centres d’intérêts,
            <br />
            ● Vos achats,
            <br />
            ● Les détails de votre navigation (sur le Site, les pages de réseaux
            sociaux, les applications),
            <br />
            ● Vos informations publiques sur les réseaux sociaux ou sur notre
            Site et applis (par exemple : avis sur un produit, un événement ou
            un service),
            <br />
            ● Vos demandes et/réclamations via notre service client ou relation
            clientèle,
            <br />● Eventuellement votre image si vous partagez votre photo en
            ligne, ou si vous participez à un événement photographié ou filmé,
            avec votre consentement le cas échéant, ou votre voix si vous
            appelez notre service de relation client (appel susceptible d’être
            enregistré)
          </p>
          <p className="title3">b. 4 Personnalisation de votre profil</p>
          <p className="disc">
            Vos Données Personnelles permettent de compléter votre profil afin
            de vous fournir des contenus, communications ou services
            personnalisés. Pour cela, HAPPER est susceptible d’utiliser des
            techniques de profilage pour évaluer et anticiper vos préférences
            et/ou vos intérêts personnels. Vous pouvez à tout moment vous
            opposer à l’utilisation de ces techniques de profilage.
          </p>
          <p className="title3">b.5 Conservation des données</p>
          <p className="disc">
            Les données sont conservées pendant la durée de l’existence de votre
            compte sur les applications HAPPER.
            <br />
            Lors de la suppression de votre compte toutes vos données citées
            ci-dessus sont supprimées.
            <br />
            Les utilisateurs peuvent contacter HAPPER à tout moment pour toute
            question relative à la politique de confidentialité ou à
            l'utilisation de l'application. Les utilisateurs peuvent également
            demander la suppression de leurs données personnelles en nous
            contactant à l’adresse <a href="">contact@happer.fr</a>
          </p>
        </>
      </div>
    </>
  );
}

export default CONFIDENTIALITE;
